import { render } from "./UserDeptPage.vue?vue&type=template&id=79cfff08"
import script from "./UserDeptPage.vue?vue&type=script&lang=js"
export * from "./UserDeptPage.vue?vue&type=script&lang=js"

import "./UserDeptPage.vue?vue&type=style&index=0&id=79cfff08&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__